// extracted by mini-css-extract-plugin
module.exports = {"Admin":"Admin__Admin--3Ut_G","AdminInner":"Admin__AdminInner--1xePy","Title":"Admin__Title--4DwII","Buttons":"Admin__Buttons--3tyzx"};